import React from 'react'
import { appConfig } from '@/config/app'

const loaderUi = appConfig.ui.loader

const Loader: React.FC<{size?: number}> = ({ size = 32 }) => (
  <div className="flex items-center justify-center w-full h-full">
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <circle
        cx="16"
        cy="16"
        r="14"
        stroke={loaderUi.trackStrokeHex}
        strokeWidth="4"
        strokeDasharray="22 22"
        strokeLinecap="round"
        opacity={loaderUi.trackOpacity}
      />
      <circle
        cx="16"
        cy="16"
        r="14"
        stroke={loaderUi.spinnerStrokeHex}
        strokeWidth="4"
        strokeDasharray="22 22"
        strokeLinecap="round"
      />
    </svg>
  </div>
)

export default Loader;
